//widgets/_new/cards/vendors/distribution/accounts/AccountInfoCard.tsx
import React, { FC } from 'react'
import { useAccount } from '../../../../../../widgets'
import {
  caribbeanDistributors,
  israelDistributors,
} from '../distributor-data'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons'

const AccountInfoCard: FC = () => {
  const { selectedAccountID } = useAccount()

  const selected = [...caribbeanDistributors, ...israelDistributors].find(
    (d) => d.AccountID === selectedAccountID
  )

  if (!selected) return null

  return (
    <div
      className='card h-100 min-h-100'
      style={{
        background: 'linear-gradient(45deg,#F1467A,#FB949E)',
        fontSize: '1rem',
        minHeight: '13rem',
      }}
    >
      <div className='d-flex flex-column mt-4 mx-4'>
        <div className='d-flex flex-row mb-4'>
          {selected.ImageUrl ? (
            <img
              src={selected.ImageUrl}
              alt='profile'
              style={{ height: 90, width: 90, borderRadius: '20%' }}
            />
          ) : (
            <div
              className='d-flex justify-content-center  align-items-center align-content-center'
              style={{
                border: '1px dashed white',
                height: 90,
                width: 90,
              }}
            >
              <FontAwesomeIcon
                icon={faUser}
                style={{ color: 'white', fontSize: '4rem' }}
              />
            </div>
          )}

          <div className='d-flex flex-column ms-4'>
            <div className='fw-bolder fs-1'>
              {selected.Name}
              <div className='fw-bold fs-5 my-2 mb-0'>{selected.BusinessName}</div>
            </div>
            {/* 
              <div className='d-flex'>
                <div className='fw-bold'>Account ID:</div>
                <div className='ms-2'>{selected.AccountID}</div>
              </div>
            */}
          </div>
        </div>

        <div
          className='mb-2 mt-2'
          style={{
            borderBottom: '1px solid rgba(247,247,247,0.5)',
            margin: '0 2%',
          }}
        />

        <div className='d-flex fw-bold my-2 mb-0 align-items-center'>
          <FontAwesomeIcon icon={faPhone} style={{ fontSize: '1.2rem' }} />
          <div className='ms-4 fs-6'>{selected.ContactInfo}</div>
        </div>

        <div className='d-flex fw-bold align-items-center' style={{ margin: '11.5px 0' }}>
          <FontAwesomeIcon icon={faLocationDot} style={{ fontSize: '1.2rem' }} />
          <div className='ms-4 fs-6'
            style={{
              overflow: 'hidden',           // Ensures content doesn't overflow
              textOverflow: 'ellipsis',     // Shows '...' when content overflows
              whiteSpace: 'wrap',         // Prevents line breaks (keeps text on one line)
              maxWidth: 'calc(100% - 35px)' // Adjust the width according to the available space
            }}
          >{selected.Address}</div>
        </div>
      </div>
    </div>
  )
}

export { AccountInfoCard }